export default "/images/light-icon.png?bf4413fcae4f12c77ebed2c1a47b9e53";